import { render, staticRenderFns } from "./TopPostsCard.vue?vue&type=template&id=6c115a04&"
import script from "./TopPostsCard.vue?vue&type=script&lang=js&"
export * from "./TopPostsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports